import Tranding_category from './trendingCategory/Tranding_categories.jsx';
import CoverflowCarousel from './CoverflowCarousel.jsx';
import NewseLatter from './NewseLatter.jsx';
import ByCelebrity from './ByCelebrity.jsx';
import Auctions_categories from './Auctions_categories.jsx';
import Header from './Header.jsx';

export {
  Auctions_categories,
  Tranding_category,
  CoverflowCarousel,
  ByCelebrity,
  NewseLatter,
  Header,
};
